import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import PayloftLogo from "../assets/images/payloft-logo.png";
import Migrate from "../assets/images/migrate.png";
import ProfilePhoto from "../assets/images/profile-photo.png";
import { getProfileInfo } from "../services/settings";
import { useAuth } from "../context/AuthContextProvider";
import toast from "react-hot-toast";
import ProfileFooter from "./ProfileFooter";
import MigrateModal from "./MigrateModal";

const SettlementNav = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const { user, logout, setIsModalOpen, isModalOpen, globalProfile } =
    useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false); // State to manage sidebar visibility

  const inactiveClass = "flex items-center py-2 px-5 gap-3 text-gray-400";
  const activeClass = "flex items-center py-2 px-5 gap-3 text-primary relative";

  const links = [
    {
      to: "/settlement-report",
      text: "Settlement",
    },
    // {
    //   to: "/transactions/refunds",
    //   text: "Refunds",
    // },
    // {
    //   to: "/transactions/chargebacks",
    //   text: "Chargebacks",
    // },
  ];

  const handleProfileInfo = async () => {
    try {
      const res = await getProfileInfo();
      if (res.data.base64File) {
        // Convert binary data to a data URL
        const dataUrl = `data:image/jpeg;base64,${res.data.base64File}`;
        setPreviewImage(dataUrl);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    handleProfileInfo();
  }, []);

  return (
    <div className="bg-arena-background h-full font-LT">
      <div className="flex">
        {/* Sidebar */}
        <div
          className={`bg-white h-screen md:w-[22%] xl:w-[13%] w-[267px] pt-4 z-50 flex flex-col justify-between ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0 fixed md:relative left-0 top-0 bottom-0 overflow-y-auto md:overflow-y-visible`}
        >
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? PayloftLogo}
              alt="logo"
              className="w-[92px] h-auto"
            />
            <div className="w-[191.98px]">
              <NavLink className="flex items-center gap-3 px-2" to="/dashboard">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.4">
                      <path
                        d="M2.35 12.35L5.14 15.14C5.46 15.46 6 15.24 6 14.79L6 13L20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11L6 11L6 9.20997C6 8.75997 5.46 8.53997 5.15 8.85997L2.36 11.65C2.16 11.84 2.16 12.16 2.35 12.35Z"
                        fill="#030229"
                      />
                    </g>
                  </svg>
                </span>
                <p className="text-gray-400 text-[12px] font-semibold">
                  Main Menu
                </p>
              </NavLink>
              <p className="text-text-orange text-base font-semibold mt-4 px-2">
                Settlement Report
              </p>
              <div>
                {links.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={
                      location.pathname === link.to
                        ? activeClass
                        : inactiveClass
                    }
                  >
                    <p className="text-base font-semibold">{link.text}</p>
                    {location.pathname === link.to ? (
                      <div className="absolute top-1/2 left-[60%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                    ) : null}
                  </NavLink>
                ))}
              </div>

              {user.migrated === true ||
              globalProfile === "PRODUCTION" ? null : (
                <div className="border-t pt-6">
                  <NavLink
                    className="flex py-3 px-5 gap-3"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <img src={Migrate} alt="migrate" className="w-6 h-6" />
                    <p className="text-gray-400 text-base font-bold">
                      Migrate to Production
                    </p>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>
        {isOpen && (
          <div
            className="bg-black opacity-50 absolute min-h-[100rem] w-full inset-0 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
        )}
        {/* Hamburger menu */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 text-2xl rounded-md"
          >
            {!isOpen ? "☰" : "✕"}
          </button>
        </div>
        {/* Main Content */}
        <div className="w-full py-5 md:px-6 md:w-[78%] xl:w-[87%]">
          <Outlet />
        </div>
      </div>
      {isModalOpen && <MigrateModal />}
    </div>
  );
};

export default SettlementNav;
